import { render } from "./StatusIndicator.vue?vue&type=template&id=fd2d0554&scoped=true&ts=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=ts"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts"

import "./StatusIndicator.vue?vue&type=style&index=0&id=fd2d0554&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd2d0554"]])

export default __exports__